module.exports = __webpack_public_path__ + "public/media/digital.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/digital.png
// module id = ./images/services/digital.png
// module chunks = 0